import { render, staticRenderFns } from "./publishList.vue?vue&type=template&id=0b56f926&scoped=true&"
import script from "./publishList.vue?vue&type=script&lang=js&"
export * from "./publishList.vue?vue&type=script&lang=js&"
import style0 from "./publishList.vue?vue&type=style&index=0&id=0b56f926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56f926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b56f926')) {
      api.createRecord('0b56f926', component.options)
    } else {
      api.reload('0b56f926', component.options)
    }
    module.hot.accept("./publishList.vue?vue&type=template&id=0b56f926&scoped=true&", function () {
      api.rerender('0b56f926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chatbotManagement/publishList.vue"
export default component.exports